import { atom } from 'jotai';

/**
 * Atom for mobile header sheet open state. Lives in its own file so consumers
 * (e.g. use-mobile-panel) can import it without pulling in store/Navigation.
 */
export const isMobileHeaderSheetOpenAtom = atom(false);
